// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"page-last"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 18V6M7.75 17.25L13 12L7.75 6.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PageLastIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-last',
    ref,
    icon: element,
  },
));

PageLastIcon.displayName = 'PageLastIcon';

export default PageLastIcon;
